/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAsyncDebounce } from 'react-table';

import { ReactComponent as SearchIcon } from '../../../assets/images/browse-icon-search.svg';
import defaultCompanyLogo from '../../../assets/images/CompanyDefaultLogo.svg';
import { ReactComponent as IconDotPoint } from '../../../assets/images/icon-point-filled.svg';
import { useJobFilterContext } from '../../../contexts/JobFilterProvider';
import { selectSearchOpeningDetails, selectSearchOpeningLoading } from '../../../selectors/browseSelectors';

import styles from './SearchByKeywords.module.scss';

export const SearchByKeywords = ({
  placeholder,
  setSearchTerm,
  keywordValue,
  setKeywordValue,
  setFetchJobsByName,
  valueSelected,
  setValueSelected,
  filters,
}) => {
  const { t } = useTranslation('common');
  const { updateSearchParams } = useJobFilterContext();

  const openingsList = useSelector(selectSearchOpeningDetails);
  const isLoadingSearchList = useSelector(selectSearchOpeningLoading);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isShowResultClicked, setIsShowResultClicked] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState([]);
  const paginatedJobResults = isShowResultClicked ? filteredOptions : filteredOptions.slice(0, 8);
  const inputRef = useRef(null);

  useEffect(() => {
    if (keywordValue?.length >= 1 && !valueSelected && openingsList) {
      const filteredByTitle = openingsList?.filter((option) =>
        option.title.toLowerCase().includes(keywordValue.toLowerCase().trim())
      );
      const filteredByExternalJobId = openingsList?.filter((option) =>
        option.external_job_id?.includes(keywordValue.trim())
      );

      const mergedResults = [...filteredByTitle, ...filteredByExternalJobId];
      const filtered = [...new Map(mergedResults.map((job) => [job.id, job])).values()];
      setFilteredOptions(filtered);
      setIsDropdownVisible(true);
    } else {
      setIsDropdownVisible(false);
      setValueSelected(false);
      setIsShowResultClicked(false);
    }
  }, [keywordValue, openingsList]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setFetchJobsByName((prevFilters) => ({
        ...prevFilters,
        ...filters,
        query: keywordValue,
        jobSearch: true,
        locationSearch: false,
      }));
      setIsDropdownVisible(false);
      setSearchTerm(keywordValue || undefined);
      setValueSelected(false);
      updateSearchParams('query', keywordValue.trim());
    }
  };

  const handleOptionClick = (option) => {
    setIsDropdownVisible(false);
    setKeywordValue(option.title);
    setFetchJobsByName((prevFilters) => ({
      ...prevFilters,
      ...filters,
      query: option.title,
      jobSearch: true,
      locationSearch: true,
    }));
    setValueSelected(true);
    setSearchTerm(option.title || undefined);
    updateSearchParams('query', option.title);
  };

  const handleSeeMoreClick = () => {
    setIsShowResultClicked(true);
  };

  const debouncedSetFetchJobsByName = useAsyncDebounce((val) => {
    setFetchJobsByName((prevFilters) => ({
      ...prevFilters,
      ...filters,
      query: val,
    }));
  }, 500);

  const handleOnChange = (val) => {
    setKeywordValue(val);
    debouncedSetFetchJobsByName(val);
    if (val === '') {
      setSearchTerm('');
      updateSearchParams('query', val);
    }
  };

  const handleClickOutside = (event) => {
    if (inputRef.current && !inputRef.current.contains(event.target)) {
      setIsDropdownVisible(false);
      setValueSelected(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.KeywordFilterContainer} ref={inputRef}>
      <input
        type="text"
        className={styles.inputText}
        value={keywordValue || ''}
        placeholder={placeholder}
        onKeyDown={handleKeyDown}
        onChange={(e) => handleOnChange(e.target.value)}
      />
      {isDropdownVisible && (
        <div className={styles.customDropdownMenu}>
          {isLoadingSearchList ? (
            <div className={styles.LoadingJobs}>{t('loading')}.....</div>
          ) : (
            paginatedJobResults.map((option, index) => (
              <React.Fragment key={option.id}>
                <div className={styles.customDropdownItem} onClick={() => handleOptionClick(option)}>
                  <div className={styles.leftContent}>
                    <SearchIcon />
                    <div className={styles.jobDetailCont}>
                      <span className={styles.jobName}>
                        {option.title} {option.external_job_id ? `- ${option.external_job_id}` : ''}
                      </span>
                      <span className={styles.JobCompany}>
                        <IconDotPoint />
                        {option.organization_name}
                      </span>
                      <span className={styles.JobCompany}>
                        <IconDotPoint />
                        {option.work_place_type}
                      </span>
                    </div>
                  </div>
                  <img className={styles.logo} src={option.logo_image_url || defaultCompanyLogo} alt="companyLogo" />
                </div>
                {index === 7 && !isShowResultClicked && (
                  <div onClick={handleSeeMoreClick} className={styles.seeMoreBtn}>
                    {t('buttons.seeAllResults')}
                  </div>
                )}
              </React.Fragment>
            ))
          )}
        </div>
      )}
    </div>
  );
};
